export default __webpack_public_path__ + "static/media/dropdown-selection.6e0e85a2.svg";